export const uiPartners = state => state.uiPartners;
export const uiPartnersLoadInProgress = state => state.uiPartners === null;

export const uiQueues = state =>
  uiPartnersLoadInProgress(state)
    ? null
    : [].concat.apply(
        [],
        state.uiPartners
          .filter(partner => partner.enabled === true)
          .map(partner =>
            partner.queues.map(queue => ({
              partnerId: partner.id,
              name: queue,
            })),
          ),
      );

export const partner = state => state.partner;
export const isPartnerLoading = state => state.partner === null;
export const usersAdmin = state =>
  state.partner ? state.partner.users.filter(u => u.admin === true) : null;
export const usersTech = state =>
  state.partner ? state.partner.users.filter(u => u.admin === false) : null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/partners.js